<template>
  <div class="container">
    <i @click="change" class="el-icon-circle-close"></i>
    <div class="img_box">
      <img style="width: 100%" :src="value.logo" />
    </div>
    <div class="title_box">
      <div class="title">{{ value.name }}</div>
      <div class="price_box">
        <div class="num">{{ value.sellCount }}人报名</div>
        <div class="price">￥{{ value.price }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Object,
      default: {},
    },
  },
  name: "gooditem",

  data() {
    return {};
  },

  created() {},
  methods: {
    //#region 表单
    change() {
      this.$emit("deleteD", this.value.id);
    },
    edit(type, val, prop) {
      //console.log(type,val,prop);
      if (type === "delete") {
        this.$emit("upLoad", prop, true);
      } else {
        prop[type] = val;
        this.$emit("upLoad", prop, false);
        console.log("prop", prop);
      }
      //  this.$emit('change',)
    },
    dele(record) {},
    showForm(params = {}) {},
  },
};
</script >
<style lang="less" scoped>
.container {
  cursor: move;
  position: relative;
  box-shadow: 0px 0px 13px -2px #5a5a5a;
  width: 300px;
  height: 370px;
  display: flex;
  flex-direction: column;
  i {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    font-size: 1.4rem;
    display: block;
    color: #8e8e8e;
    &:hover {
      transition: all 0.2s linear;
      color: #409eff;
      cursor: pointer;
    }
  }
  .img_box {
    height: 300px;
  }
  .title_box {
    padding: 1rem;
    flex: 1;
    .title {
      height: 50%;
    }
    .price_box {
      height: 50%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .num {
        font-size: 0.8rem;
        color: #aaaaaa;
      }
      .price {
        font-size: 1.5rem;
        color: red;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/addGuide/components/GoodItem.vue